<template>
  <div class="container">
    <transition name="modal fade">
      <div class="modal-mask modal-backdrop dropdown_modal">
        <div class="modal-wrapper">
          <div class="modal-dialogs" role="document">
            <div class="modal-content modal-xs bg-transparent">
              <div class="modal-body mdScroll px-5 craft-weapon_list linear-gradient-color mb-3">
                <div class=" linear-gradient-color inner_content">
                <h1 class="tm5 modal-title d-inline-block">Deposit Amount</h1>
                <a
                  href="JavaScript:void(0)"
                  class="btn-cross float-right close-modal"
                  @click="hideModal($event)"
                  >X</a
                >
                <p v-if="error">{{ error }}</p>
                <div class="text-center"></div>
                <div class="withdraw_inner">
                  <input type="number" class="form-control" v-model="amount" placeholder="Please enter deposit amount, e.g 1">
                  <div class="form-group mt-4">
                      <select id="my-select" class="form-control" name="type" v-model="symbol">
                          <option value="MCC" selected>MCC</option>
                          <option value="WSW">Wood WSW</option>
                          <option value="WSL">Leather WSL</option>
                          <option value="WSM">Metal WSM</option>
                      </select>
                  </div>
                   <template v-if="!loading && walletBalance.length>0">
                     <div v-for="(bal, i) in walletBalance" :key="i">
                      <span class="help-block" :class="(bal.replace(/[\d\., ]/g, '')).toLowerCase()">Wallet Balance: {{bal}}</span>
                     </div>
                   </template>
                  <button class="btn btn-dark theme_btn" @click="transfer()">Deposit</button>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
// import ApiService from "../services";
import ApiService from "../services";
// import VueLoadImage from "vue-load-image";
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
  name: "WithdrawModal",
  // components: {
  //   Loading,
  // },
  

  props: ["error", "depositModal"],
  
  data() {
    return {
      amount: null,
      token: false,
      loading:true,
      symbol: "MCC",
      walletBalance:null,
      // depositModal: true,
    };
  },
  mounted() {
    this.getBal();
  },
  methods: {
    hideModal(e) {
      this.$emit("w-modal-hide-click", e);
    },
    getBal(){
    ApiService.getWalletBalance((response)=>{
      this.loading=false
      this.walletBalance=response.data;
    });
    },
    async transfer() {
      const data = {
        contract:process.env.VUE_APP_TOKEN_CONTRACT,
        action:"transfer",
        data:{
            from: localStorage.getItem("wax_user"),
            quantity: Number(this.amount).toFixed(4)+" "+this.symbol,
            to:process.env.VUE_APP_CONTRACT,
            memo:"deposit:token"
          }
        };
      await ApiService.transaction(
        data,
        (res) => {
          if (res.processed) {
            toast.success("Transaction successfull");
            ApiService.getBalance((res) =>{
              this.$store.commit("addBalance", res.rows[0])
              this.getBal();
            });
          }
        },
        (error) => {
          toast.error(ApiService.errorFormat(error));
        }
      );
    },
  },
};
</script>

<style scoped>
.progress-cont .progress__bar {
  height: 9px !important;
}
.dropdown_modal .craft-weapon_list{
  width: 35vw;
  height: auto;
}
.inner_content{
  display: inline-block;
  width: 100%;
  padding: 20px;
  text-align: center;
}
.dropdown_modal .close-modal{
  font-family: JockeyOne !important;
  background: #e84218;
  padding: 5px 13px;
  border-radius: 5px;
  color: #fff;
  text-decoration: none;
  font-weight: bold;
  position: absolute;
  right: 8px;
  top: 20px;
}
.modal-dialogs{
  height: 100vh !important;
  display: flex;
}
.modal-content{
  margin: auto !important;
  height: fit-content !important;
  border: none;
}
.dropdown_modal{
  background-color: rgba(0,0,0,0.4);
}
</style>
